var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19 9C19 10.45 18.57 11.78 17.83 12.89C16.75 14.49 15.04 15.62 13.05 15.91C12.71 15.97 12.36 16 12 16C11.64 16 11.29 15.97 10.95 15.91C8.96 15.62 7.25 14.49 6.17 12.89C5.43 11.78 5 10.45 5 9C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9Z",
    fill: "#FFB627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2501 18.4684L19.6001 18.8584C19.2301 18.9484 18.9401 19.2284 18.8601 19.5984L18.5101 21.0685C18.3201 21.8685 17.3001 22.1085 16.7701 21.4785L12.0001 15.9984L7.23008 21.4884C6.70008 22.1184 5.68008 21.8784 5.49008 21.0784L5.14008 19.6084C5.05008 19.2384 4.76008 18.9484 4.40008 18.8684L2.75008 18.4785C1.99008 18.2985 1.72008 17.3484 2.27008 16.7984L6.17008 12.8984C7.25008 14.4984 8.96008 15.6285 10.9501 15.9185C11.2901 15.9785 11.6401 16.0085 12.0001 16.0085C12.3601 16.0085 12.7101 15.9785 13.0501 15.9185C15.0401 15.6285 16.7501 14.4984 17.8301 12.8984L21.7301 16.7984C22.2801 17.3384 22.0101 18.2884 21.2501 18.4684Z",
    fill: "#FFB627"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.58 5.98L13.17 7.15999C13.25 7.31999 13.46 7.48 13.65 7.51L14.72 7.68999C15.4 7.79999 15.56 8.3 15.07 8.79L14.24 9.61998C14.1 9.75998 14.02 10.03 14.07 10.23L14.31 11.26C14.5 12.07 14.07 12.39 13.35 11.96L12.35 11.37C12.17 11.26 11.87 11.26 11.69 11.37L10.69 11.96C9.96997 12.38 9.53997 12.07 9.72997 11.26L9.96997 10.23C10.01 10.04 9.93997 9.75998 9.79997 9.61998L8.96997 8.79C8.47997 8.3 8.63997 7.80999 9.31997 7.68999L10.39 7.51C10.57 7.48 10.78 7.31999 10.86 7.15999L11.45 5.98C11.74 5.34 12.26 5.34 12.58 5.98Z",
    fill: "#FFB627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal03);
export default __webpack_public_path__ + "static/media/medal-03.ae70bd5b755798be6d3161135ba768de.svg";
export { ForwardRef as ReactComponent };